import cookie from 'cookie';
import { dateFormat, dateAdd } from './date.js';

export default {
    setItem: (name, value, options = {}) => {
        // setCookie('myCookie', 'the value of the cookie', {
        //     domain: '.example.org'
        // });
        if(!options.maxAge) {
            options.maxAge = 2 * 30 * 24 * 60 * 60;
        }
		console.log('Cookie::: Set', name, value, options);
		document.cookie = cookie.serialize(name, value, options);
    },

    getItem: name => {
        const value = cookie.parse(document.cookie)[name];
		console.log('Cookie::: Get', name, value);
		return value;
    },
};
